// The full Shipment Method of Payment code list (DE 146) — shared by every
// FOB01 element across transaction sets. Union of the previous hand-picked
// FOB01 subset (header-segments.ts) and the 856-specific FOB01 list in
// reference/session/856-ship-notice-manifest-qualifiers-txt.md.

import type {CodeListEntry} from './types';

export const SHIPMENT_METHOD_OF_PAYMENT_CODES: CodeListEntry[] = [
  {code: 'CC', label: 'Collect'},
  {code: 'PP', label: 'Prepaid'},
  {code: 'PC', label: 'Prepaid but Charged to Customer'},
  {code: 'TP', label: 'Third Party Pay'},
  {
    code: 'DF',
    label:
      'Defined by Buyer and Seller (freight negotiated outside this document)',
  },
  {code: 'PU', label: 'Pickup'},
  {code: 'NC', label: 'Service Freight, No Charge'},
  {code: 'MX', label: 'Mixed'},
];
